export {
  default,
  type GridColProps,
  type GridColAlignType,
  type GridColOffset,
  type GridColOrder,
  type GridColWidth,
  gridColAlignments,
} from './GridCol';
